import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldX, Mail } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const AccessDenied = () => {
  const { logout, accessError } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <ShieldX className="h-16 w-16 text-destructive" />
          </div>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You do not have permission to access this application
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-4">
              {accessError || 'Your account has not been invited to use this application. Please contact your administrator for access.'}
            </p>

            <div className="bg-muted p-4 rounded-lg text-left space-y-2">
              <p className="text-sm font-medium">To request access:</p>
              <ul className="text-sm text-muted-foreground space-y-1 ml-4">
                <li>• Contact your healthcare administrator</li>
                <li>• Request an invitation to healthscores.ai</li>
                <li>• They will create your account in the system</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <Button
              variant="outline"
              onClick={() => window.location.href = 'mailto:support@healthscores.ai?subject=Access Request'}
              className="w-full"
            >
              <Mail className="h-4 w-4 mr-2" />
              Contact Support
            </Button>
            <Button
              variant="ghost"
              onClick={logout}
              className="w-full"
            >
              Sign Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;
